import React, { useState, useRef, useEffect } from 'react';
import './TabMenu.style.css';
import { RightOutlined } from '@ant-design/icons';

const TabMenu = ({
  items = [],
  activeKey,
  collapseKey = [],
  onChange = () => {},
  prefix = <RightOutlined />,
  suffix,
  multi = true,
  defaultKey = null,
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const [key, setKey] = useState(activeKey ?? null);
  const [cKey, setCKey] = useState(collapseKey);
  const [subMenuHeights, setSubMenuHeights] = useState([]);
  const subMenuRefs = useRef([]);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  const handleTabKeyChange = ({ label, key, children, ...rest }) => {
    setKey(key);
    onChange && onChange({ label, key, children, ...rest });
  };

  const handleTabCollapse = (k) => {
    setCKey((prev) =>
      prev.includes(k) ? prev.filter((item) => item !== k) : [...prev, k]
    );
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  useEffect(() => {
    const heights = subMenuRefs.current.map((ref) => ref?.scrollHeight || 0);
    setSubMenuHeights(heights);
  }, [cKey]);

  useEffect(() => {
    if (multi) return;

    const isExist = items.some((item) => item.key === activeKey);
    if (isExist) return;
    else setKey(null);
  }, [multi, items, activeKey]);

  useEffect(() => {
    setKey(activeKey ?? null);
  }, [activeKey]);

  // 기본값설정
  useEffect(() => {
    defaultKey && setKey(defaultKey);
  }, [defaultKey]);

  /* ===== Render ===== */
  return (
    <div className="tabmenu_wrapper">
      <ul className="tabmenu_container">
        {items.map((_item, _index) => (
          <li
            key={items.key ?? `tab_${_index}`}
            className={`tabmenu_item ${_item.key === key ? 'active' : ''}`}
          >
            <p
              onClick={() =>
                _item.children
                  ? handleTabCollapse(_item.key ?? `tab_${_index}`)
                  : handleTabKeyChange(_item)
              }
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              {_item.label}
              {suffix !== 'none' && (
                <span>
                  {suffix ?? (
                    <RightOutlined
                      style={{
                        transform:
                          _item.children &&
                          cKey.includes(_item.key ?? `tab_${_index}`)
                            ? 'rotate(90deg)'
                            : 'none',
                        transition: 'transform 0.3s',
                      }}
                    />
                  )}
                </span>
              )}
            </p>
            {_item.children && (
              <ul
                ref={(el) => (subMenuRefs.current[_index] = el)}
                className={`sub_tabmenu ${
                  cKey.includes(_item.key ?? `tab_${_index}`) ? 'collapsed' : ''
                }`}
                style={{
                  maxHeight: cKey.includes(_item.key ?? `tab_${_index}`)
                    ? subMenuHeights[_index]
                    : 0,
                }}
              >
                {_item.children.map((_subitem, _subindex) => (
                  <li
                    key={_subitem.key ?? `sub_tab_${_subindex}`}
                    className={`tabmenu_item ${
                      _subitem.key === key ? 'active' : ''
                    }`}
                    onClick={() => handleTabKeyChange(_subitem)}
                  >
                    <p
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {prefix}
                      {_subitem.label}
                    </p>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TabMenu;
